import React, { useState } from "react";
import { Check, Copy, KeyRound, Mail } from "lucide-react";
import { toast } from "sonner";
import { cn } from "@/lib/utils";
import { copyText, credentialsMessage, firstName } from "@/lib/brukere";

function CopyBtn({ text, label, done, testId, primary }) {
  const [ok, setOk] = useState(false);
  const go = async () => {
    const r = await copyText(text);
    if (r) { setOk(true); toast.success(done); setTimeout(() => setOk(false), 1800); } else toast.error("Kunne ikke kopiere – marker teksten og kopier manuelt");
  };
  return (
    <button type="button" onClick={go} className={cn("inline-flex h-9 items-center gap-1.5 rounded-full px-3.5 text-[13px] font-medium transition-colors", primary ? "bg-[hsl(var(--navy))] text-white hover:bg-[hsl(var(--ink-2))]" : "border border-black/[0.1] bg-white text-foreground/80 hover:border-black/[0.25] hover:text-foreground")} data-testid={testId}>
      {ok ? <Check className="h-3.5 w-3.5" strokeWidth={2.6} /> : <Copy className="h-3.5 w-3.5" />} {label}
    </button>
  );
}

/** Shown exactly once, right after the server made the password. Nothing here is stored in the browser. */
export function Credentials({ name, email, password, reason = "created", testId = "credentials" }) {
  const message = credentialsMessage({ name, email, password });
  const mailto = `mailto:${encodeURIComponent(email)}?subject=${encodeURIComponent("Tilgang til LOS Marine Workspace")}&body=${encodeURIComponent(message)}`;
  return (
    <div className="rounded-[16px] border border-black/[0.07] bg-[hsl(210_20%_98.5%)] p-4 fade-up" data-testid={testId}>
      <div className="flex items-center gap-2 text-[12.5px] font-medium text-foreground/70"><KeyRound className="h-3.5 w-3.5" /> {reason === "reset" ? "Nytt midlertidig passord" : "Innlogging"}</div>
      <dl className="mt-3 grid grid-cols-[auto_minmax(0,1fr)] items-baseline gap-x-4 gap-y-2 text-[13.5px]">
        <dt className="text-muted-foreground">E-post</dt>
        <dd className="truncate font-medium" data-testid={`${testId}-email`}>{email}</dd>
        <dt className="text-muted-foreground">Passord</dt>
        <dd className="select-all break-all font-mono text-[17px] font-medium tracking-[0.04em] text-[hsl(var(--navy))]" data-testid={`${testId}-password`}>{password}</dd>
      </dl>
      <div className="mt-4 flex flex-wrap items-center gap-2">
        <CopyBtn text={message} label="Kopier innloggingsinfo" done="Innloggingsinfo kopiert – lim den inn i en melding" testId={`${testId}-copy-all`} primary />
        <CopyBtn text={password} label="Kopier passord" done="Passordet er kopiert" testId={`${testId}-copy-password`} />
        <a href={mailto} className="inline-flex h-9 items-center gap-1.5 rounded-full px-3 text-[13px] font-medium text-foreground/70 hover:bg-black/[0.05] hover:text-foreground" data-testid={`${testId}-mail`}><Mail className="h-3.5 w-3.5" /> Skriv e-post</a>
      </div>
      <p className="mt-3 text-[12px] leading-relaxed text-muted-foreground">Passordet vises bare nå og lagres kun som hash. {firstName(name) || "Brukeren"} velger sitt eget passord ved første innlogging{reason === "reset" ? ", og alle tidligere økter er allerede logget ut" : ""}.</p>
    </div>
  );
}
